import { deepMerge } from 'js/utils/Utils'
import { PerspectiveCamera } from 'three'
import { calcViewportDistance } from 'js/utils/Maths'

const defaults = {
  instanceName: 'ExPerspectiveCamera',
  cameraProps: {
    near: 0.01,
    far: 10000,
  },
  cameraPosition: {
    x: 0,
    y: 0,
    z: 0,
  },
  cameraAspect: null,
  cameraFov: 45,
  fitFovToViewport: true,
  time: 0,
  lookCenter: true,
}

export default class BasePerspectiveCameraController {
  constructor(options = {}) {
    this.stage = null
    this.renderer = null
    this.basePosition = {
      x: 0,
      y: 0,
      z: 0,
    }

    deepMerge(this, defaults, options)
  }

  init() {
    this._setInstance()
    this._setCamera()
    this._setPosition()
  }

  destroy() {
    this.instance.clearViewOffset()
    this.instance = null
  }

  _setInstance() {
    this.instance = new PerspectiveCamera()
    deepMerge(this.instance, this.cameraProps)
  }

  _setCamera() {
    this._setFov()
    this._setBasePosition()
    this.instance.updateProjectionMatrix()
    this.renderer.setSize(this.stage.stageSize.width, this.stage.stageSize.height)
  }

  _setFov() {
    this.instance.aspect = this.cameraAspect ? this.cameraAspect : this.stage.stageSize.aspect.xy || document.body.clientWidth / window.innerHeight
    this.instance.fov = this.cameraFov
  }

  _setBasePosition() {
    this.basePosition.x = this.cameraPosition.x
    this.basePosition.y = this.cameraPosition.y

    if (this.fitFovToViewport) {
      this.basePosition.z = calcViewportDistance(this.stage.stageSize.height, this.instance.fov)
    } else {
      this.basePosition.z = this.cameraPosition.z
    }
  }

  _setPosition() {
    this.instance.position.x = this.basePosition.x
    this.instance.position.y = this.basePosition.y
    this.instance.position.z = this.basePosition.z
  }

  onResize() {
    this._setCamera()
  }

  onRaf() {
    this._setPosition()
  }
}